import { ArrowDownRight } from 'lucide-react'
import { Button } from './ui/button'
import { Link, useLocation } from '@remix-run/react'

interface ScrollToElementButtonProps {
    readonly elementId: string
    readonly text: string
}

export function ScrollToElementButton({
    elementId,
    text,
}: ScrollToElementButtonProps) {
    const location = useLocation()

    return (
        <Link
            tabIndex={-1}
            to={`${location.pathname}${location.search}#${elementId}`}
            className='group'
        >
            <Button className='py-8 bg-companyBlack font-semibold rounded-full text-md relative z-[2] duration-300 transition-all ease-in-out border-[3px] border-companyBlack group-hover:bg-white group-hover:text-companyBlack'>
                <span className='mr-2'>{text}</span>
                <div className='p-2 rounded-full duration-200 transition-all ease-in-out bg-white text-companyBlack group-hover:bg-companyBlack group-hover:text-white'>
                    <ArrowDownRight className='rotate-0 transition-transform delay-100 duration-300 ease-in-out  group-hover:rotate-45' />
                </div>
            </Button>
        </Link>
    )
}
